const BASE_URL = process.env.REACT_APP_BASE_URL;
const IDPID = process.env.REACT_APP_IDPID;

export const getConfigurations = async () => {
    const url = `${BASE_URL}/config/configurations?idpid=tsp`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to get config');
    }
    return await response.json();
};

export const getMaxFileSize = async () => {
    const url = `${BASE_URL}/config/max-file-size`;
    const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error('Failed to get max file size');
    const { maxFileSize } = await response.json();  // { maxFileSize: 5242880 }
    return maxFileSize;
};

export const fetchMinBrowserConfig = async () => {
    const url = `${BASE_URL}/config/browser/min/current?idpid=tsp`;
    const resp = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    });

    // 204 => no hay cuerpo; devolvemos null
    if (resp.status === 204) return null;
    if (!resp.ok) throw new Error('Config fetch failed');

    // Algunos servidores no mandan content-length; protegemos el json()
    const text = await resp.text();
    if (!text) return null;
    return JSON.parse(text); // => { type, version, label }
};
